import React from 'react';

import Modal from 'components/cosmos/modal';
import I18n from 'components/translate/I18n';
import PropTypes from 'prop-types';

import './ConfirmationModal.scss';

const ConfirmationModal = ({
  children,
  title,
  description = '',
  subtitle = '',
  confirmLabel,
  isOpen,
  onConfirm,
  onCancel
}) => {
  const header = (
    <>
      <h5 className="config-streaming-confirmation-modal__title">
        <I18n label={title} />
      </h5>
      {subtitle && (
        <div className="config-streaming-confirmation-modal__subtitle">
          <I18n label={subtitle} />
        </div>
      )}
    </>
  );

  const footer = (
    <>
      <button
        className="hot-button hot-button--primary hot-button--lg _mr-4"
        onClick={onConfirm}
      >
        <I18n label={confirmLabel} />
      </button>
      <button
        className="hot-button hot-button--secondary hot-button--lg"
        onClick={onCancel}
      >
        <I18n label="general.cancel" />
      </button>
    </>
  );

  return (
    <Modal header={header} footer={footer} open={isOpen} onClose={onCancel}>
      {description && (
        <div className="config-streaming-confirmation-modal__description">
          <I18n label={description} />
        </div>
      )}
      {children}
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  subtitle: PropTypes.string,
  confirmLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ConfirmationModal;
